import * as React from 'react';
import { render } from 'react-dom';
import './DialogTypes.scss';

let resolve: any;

const initialState = {
    isOpen: false,
    confirmProps: {} as IProps,
    defaultAffirmative: 'OK',
    defaultNegative: 'Cancel'
};

type State = Readonly<typeof initialState>;

interface IProps {
    title               : string;
    message             : string;
    messageContent?     : React.ReactNode;
    affirmativeLabel?   : string;
    negativeLabel?      : string;
}

class ResultDialog extends React.Component<any, State> {

    public static create() {

        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);

        return render(<ResultDialog
            title={''}
            message={''}
        />, containerElement);

    }

    public state : State = initialState;

    public handleCancel = () => {
        this.setState({ isOpen: false });
        resolve(false);
    }

    public handleConfirm = () => {
        this.setState({ isOpen: false });
        resolve(true);
    }

    public show = (props: IProps) => {

        this.setState({
            isOpen: true,
            confirmProps: props
        });

        return new Promise((res) => {
            resolve = res;
        });

    }

    public render() {

        const { isOpen, confirmProps, defaultAffirmative, defaultNegative } = this.state;

        const affirmLabel = confirmProps.affirmativeLabel ? confirmProps.affirmativeLabel : defaultAffirmative;
        const negLabel = confirmProps.negativeLabel ? confirmProps.negativeLabel : defaultNegative;

        return (
            <div className={`result-dialog ${isOpen ? "show" : ""}`} onClick={this.handleCancel}>
                <div className="result-dialog-backdrop" />
                <div className="result-dialog-content">
                    <div className="result-dialog-modal">    
                        <div className="result-dialog-header">
                            <h2>{confirmProps.title}</h2>
                        </div>                    
                        <div className="result-dialog-body">
                            {confirmProps.messageContent ?? <p>{confirmProps.message}</p>}
                        </div>
                        <div className="result-dialog-footer">
                            <button className="btn-flat positive" onClick={this.handleConfirm}>{ affirmLabel }</button>
                            <button className="btn-flat negative" onClick={this.handleCancel}>{ negLabel }</button>
                        </div>                                        
                    </div>
                </div>
            </div>
        );
    }
}

export default ResultDialog.create() as any;
